module.exports = __webpack_public_path__ + "static/img/cover1.06fa6939.jpg";